import { useState } from 'react';
import { Modal } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { setModalState } from '../../../../reducers/Modal/actions';
import { MODAL_BULK_SUBMIT_PRE_DEALS } from '../../../../reducers/Modal/types';
import { getStepComponent } from './service';
import { BULK_SUBMIT_SELECT_SOURCE, BULK_SUBMIT_SUBMITTED } from './constants';
import { fetchPreDeals } from '../../../../reducers/PreDeal/actions';
import { PREDEFINED_VIEWS } from '../MyPreDeals/constants';

import './index.scss';

export const BulkSubmitPreDealsModal = ({ setPredefinedView }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [wizardStep, setWizardStep] = useState(BULK_SUBMIT_SELECT_SOURCE);
  const [data, setData] = useState([]);
  const [duplicatesCounter, setDuplicatesCounter] = useState(0);
  const dispatch = useDispatch();
  const { isBulkSubmitPreDealsModalOpen } = useSelector(
    ({ ModalReducer }) => ModalReducer,
  );
  const { currentPage, pageSize } = useSelector(
    ({ PreDealReducer }) => PreDealReducer,
  );
  const { appliedFilters } = useSelector(
    ({ PropertyReducer }) => PropertyReducer,
  );
  const handleClose = () => {
    if (wizardStep === BULK_SUBMIT_SUBMITTED) {
      setPredefinedView(PREDEFINED_VIEWS.ALL_DEALS);
      dispatch(fetchPreDeals({ page: currentPage, pageSize, appliedFilters }));
    }
    setWizardStep(BULK_SUBMIT_SELECT_SOURCE);
    dispatch(setModalState(MODAL_BULK_SUBMIT_PRE_DEALS, false));
  };

  const stepComponent = getStepComponent(wizardStep, {
    onReset: handleClose,
    setWizardStep,
    setData,
    data,
    isLoading,
    setIsLoading,
    setDuplicatesCounter,
    duplicatesCounter,
  });

  return (
    <Modal
      className="bulk-submit-pre-deals-modal"
      open={isBulkSubmitPreDealsModalOpen}
      footer={null}
      onCancel={handleClose}
      destroyOnClose
      closable={!isLoading}
      maskClosable={!isLoading}
      keyboard={!isLoading}
    >
      {stepComponent}
    </Modal>
  );
};
